export const USER_ACTION_TYPES = {
  SET_CURRENT_USER: 'user/SET_CURRENT_USER',
  CHECK_USER_SESSION: 'user/CHECK_USER_SESSION',
  SET_IS_ACCOUNT_CARD_OPEN: 'user/SET_IS_CART_OPEN',
};